export const Presentational = (props) => {
  return (
    <QuoteBox propys={props} />
  );
}

const QuoteBox = (props) => {
  const propys = props.propys;
  return (
    <div id="quote-box">
      <div id="imageBird">
        <img src="https://cdn.pixabay.com/photo/2016/04/10/21/28/animal-1320792_960_720.png" alt="heart illustration"/>
      </div>
      <TopComponent state={propys.state}/>
      <BottomComponent newQuote={propys.newQuote} />
    </div>
  );
}

const TopComponent = (props) => {
  const currentQuote= props.state.currentQuote;
  return (
    <div className="Quote">
      <p id="text" >
        {currentQuote["quote"]}
      </p>
      <blockquote id="author">
        {currentQuote["author"]}
      </blockquote>
    </div>
  );
}
const BottomComponent = (props) => {
  return (
    <div className="buttons">
      <a 
        id="tweet-quote"
        target="_blank"
        rel="noopener noreferrer"
        href="https://twitter.com/intent/tweet"
      >
        <button >
          Tweet It!{" "}<i className="fa fa-twitter"></i>
        </button>
      </a>
      <button 
        onClick={props.newQuote.bind(this, Math.floor(Math.random()*10))} 
        id="new-quote"
      >
        New quote <i className="fa fa-chevron-right"></i>
      </button>
    </div>
  );
}